import { useMemo } from 'react'
import HeaderButton from './HeaderButton'
import Icon from '../Icon'
import Box from '../Box'
import Checkbox from '../Checkbox'
import { includes } from 'lodash'

const TableHeader = ({
  sortKey,
  sortOrder,
  handler: onSorted,
  fixHeight: fixedHeight,
  text,
  children,
  // checkbox props
  checkbox,
  checked,
  disabled,
  onChange,
  ...stylingProps
}) => {
  const [orders, sortKeys] = useMemo(() => {
    const arrange = Array.isArray(sortOrder) ? [...sortOrder] : []
    const sortKeys = arrange.map((strKey) => (strKey.startsWith('-') ? strKey.slice(1) : strKey))
    return [arrange, sortKeys]
  }, [sortOrder])

  const sortIndex = sortKeys.indexOf(sortKey)
  const isSorting = sortIndex !== -1

  const handleSort = () => {
    if (!sortKeys.length) {
      onSorted([sortKey])
    } else if (!includes(sortKeys, sortKey)) {
      onSorted(orders.concat([sortKey]))
    } else {
      const newOrders = []
      for (const strKey of orders) {
        const isDesc = strKey.startsWith('-')
        const key = isDesc ? strKey.slice(1) : strKey
        if (key === sortKey) {
          if (isDesc) continue
          newOrders.push(`-${sortKey}`)
        } else {
          newOrders.push(strKey)
        }
      }
      onSorted(newOrders)
    }
  }

  const isAscActive = () => isSorting && includes(orders, sortKey)

  const isDescActive = () => isSorting && includes(orders, `-${sortKey}`)

  if (sortKey) {
    return (
      <HeaderButton {...stylingProps} onClick={handleSort} pointer>
        <div className='table-header-button' style={{ height: fixedHeight }}>
          <div className='text'>{children ?? text}</div>
          <div className='sort-wrapper'>
            <Icon name='sortUp' fill={isAscActive() ? '#28293d' : '#dedee6'} />
            <Icon name='sortDown' fill={isDescActive() ? '#28293d' : '#dedee6'} />
          </div>
          {isSorting && <div className='sort-index'>{sortIndex + 1}</div>}
        </div>
      </HeaderButton>
    )
  } else if (checkbox) {
    return (
      <HeaderButton>
        <Box className='table-header-button'>
          <div className='text'>
            <Checkbox checked={checked} onChange={onChange} disabled={disabled} />
          </div>
        </Box>
      </HeaderButton>
    )
  }

  return (
    <HeaderButton {...stylingProps}>
      <div className='table-header-button'>
        <div className='text'>{children ?? text}</div>
      </div>
    </HeaderButton>
  )
}

export default TableHeader
